
// import { AxiosError } from "axios";
// import { STATUS } from "../common/constant";
import { BaseService } from "./base.service";
import { IErrorResponse, ISuccessResponse } from "./interface/ApiResponse.interface";
import { IChangePassword, IContact, IDelete, IEmail, IForgotPassword, IForgotPassword3, Ilogin, IOtp, IProfile, IReferal, IReferalSms, ISignUp, IToken } from "./interface/auth.interface";
export class AuthService extends BaseService {
    public async Signup(signup: ISignUp): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.post("auth/register/", signup);
            return data;
        } catch (error: any) {
            return error.response.data;
        }
    }
    public async Login(signin: Ilogin) {
        try {
            const { data } = await this.httpClient.post("auth/login/", signin);
            return data;
            // if (data.status === STATUS.SUCCESS) {
            //     return data;
            // } else {
            // }
        }
        catch (error: any) {
            return error.response.data;
            // return parseAxiosError(error as AxiosError)
        }
    }
    public async ForgotPassword(forgotPassword: IForgotPassword): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.post("/auth/requestForgotPassword/", forgotPassword);
            return data;
        }
        catch (error: any) {
            return error.response.data;
        }
    }
    public async OtpVerification(otp: IOtp): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.post("/auth/forgotPasswordOTPCheck/", otp);
            return data;
        }
        catch (error: any) {
            return error.response.data;
        }
    }
    public async ForgotPassword3(forgotPassword: IForgotPassword3): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.patch("/auth/setForgotPassword/", forgotPassword);
            return data;
        }
        catch (error: any) {
            return error.response.data;
        }
    }
    public async ChangePassword(changePassword: IChangePassword): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.patch("/auth/changePassword/", changePassword);
            return data;
        }
        catch (error: any) {
            return error.response.data;
        }
    }
    public async EmailVerification(token: IToken): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.get("auth/emailVerify/", { params: token });
            // const { data } = await this.httpClient.get("auth/emailVerify/", { headers: { Authorization: `Bearer ${token.token}` } });
            return data;
        }
        catch (error: any) {
            return error.response.data;
        }
    }
    public async EmailResendVerification(verifyEmailData: IEmail): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.post("/auth/resendEmailVerificationLink/", verifyEmailData);
            return data;
        }
        catch (error: any) {
            return error.response.data;
        }
    }
    public async MobileResendVerification(verifyEmailData: IEmail): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.post("/auth/resendSMSVerification/", verifyEmailData);
            return data;
        }
        catch (error: any) {
            return error.response.data;
        }
    }
    public async DeleteAccount(Token: IDelete): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.patch("/auth/deleteAccount/", Token);
            return data;
        }
        catch (error: any) {
            return error.response.data;
        }
    }
    public async GetRefreshToken(Token: IToken): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.patch("/auth/getAccessToken/", Token);
            return data;
        }
        catch (error: any) {
            return error.response.data;
        }
    }
    public async ProfileGet(user_id: unknown, is_crud: string) {
        try {
            const { data } = await this.httpClient.get(`/hero/getProfile/?user_id=${user_id}&is_confidential=${is_crud}`);
            return data;

        }
        catch (error: any) {
            return error.response.data;

        }
    }
    public async EditProfile(profile: IProfile) {
        try {
            const { data } = await this.httpClient.post("/hero/editProfile/", profile);
            return data;

        }
        catch (error: any) {
            return error.response.data;

        }
    }
    public async ContactUs(contact: IContact): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.post("/hero/contactUS/", contact);
            return data;
        }
        catch (error: any) {
            return error.response.data;
        }
    }
    public async FaqContent() {
        try {
            const { data } = await this.httpClient.get("/hero/FAQ/");
            return data;

        }
        catch (error: any) {
            return error.response.data;

        }
    }
    public async ReferEmail(referal: IReferal): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.patch("/hero/shareReferalCodeInMail/", referal);
            return data;

        }
        catch (error: any) {
            return error.response.data;

        }
    }
    public async ReferSms(referal: IReferalSms): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.patch("/hero/shareReferalCodeInSMS/", referal);
            return data;

        }
        catch (error: any) {
            return error.response.data;

        }
    }

    public async QrGet(user_id: string) {
        try {
            const { data } = await this.httpClient.post(`/hero/getQRCode/`, user_id);
            return data;

        }
        catch (error: any) {
            return error.response.data;

        }
    }
    public async timeForAction(timeForAction: any): Promise<ISuccessResponse | IErrorResponse> {
        try {
            const { data } = await this.httpClient.post("/hero/timeForAction/", timeForAction, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return data;
        }
        catch (error: any) {
            return error.response.data;
        }
    }
    public async getAccount(user_id: unknown, page: number, limit: number) {
        try {
            const { data } = await this.httpClient.get(`/hero/getAccountDetails/?user_id=${user_id}&page=${page}&limit=${limit}`);
            return data;

        }
        catch (error: any) {
            return error.response.data;

        }
    }
    public async Offers(user_id: unknown) {
        try {
            const { data } = await this.httpClient.get(`/hero/getAccountDetails/?user_id=${user_id}`);
            return data;

        }
        catch (error: any) {
            return error.response.data;

        }
    }
    public async userManagement(page: number, limit: number) {
        try {
            const { data } = await this.httpClient.get(`/hero/userManagement/`);
            return data;

        }
        catch (error: any) {
            return error.response.data;

        }
    }

}
